import _ from 'lodash';
import store from '@/store';
import { GoodsObjectService } from '@/services/GoodsObjectService';

export function kgToSellingUnitQuantity(order: any, goodsObject: any, quantityInKg: number, unit?: string): number {
  const sellingUnit = unit || _.get(order,'product.unit.unit2','').toLowerCase();
  if(!sellingUnit) return 0;
  let perKgRatio = goodsObject.perKgRatio;
  if(!perKgRatio) return 0;
  const packingMode = goodsObject.packingMode.length > 0 ? goodsObject.packingMode : _.get(order,'product.packingMode',[]);
  const packingLevel: string = store.getters.getPackingLevelFromSellingUnit(sellingUnit, packingMode);
  if(packingLevel == 'plA' && perKgRatio[packingLevel]) {
    return Math.ceil(_.floor(perKgRatio[packingLevel].value * quantityInKg, 5));
  }
  perKgRatio = GoodsObjectService.getFGPerKGRatios(goodsObject, order);
  return perKgRatio[packingLevel] ? Math.ceil(_.floor(perKgRatio[packingLevel].value * quantityInKg, 5)) : 0;
}
